import React from 'react';
import { Container } from 'react-bootstrap';
import AppRoutes from './routes/AppRoutes';
import { useDefaultContext } from './contexts/UserContext';

function App() {


  return (
    <Container fluid={true} className="p-0">
      <>
      <AppRoutes />
      </>
    </Container>
  
  );
}

export default App;
